module.exports = __webpack_public_path__ + "assets/img/information.4a94017b.svg";